<div class="mode" [class.active]="dark" (click)="layoutToggle()">
  <app-common-svg-icon [icon]="'moon'"></app-common-svg-icon>
</div>
